module.exports = __webpack_public_path__ + "static/media/shuri-atomi-win.7eb4bb5c.jpg";